import type { BrandConfig } from './types';

/**
 * 手動登録タブの文言をブランド設定から導く (ハードコードしない)。
 *
 * 「マニュアル」の接頭辞は、Amazon 連携があって Amazon タブが先頭のとき (手動登録が副チャネル) だけ付ける。
 * それ以外 (手動登録が主チャネル・Amazon 連携なし) はブランドの呼び名だけで通じる。
 *   商品上品 (Amazon 先頭)            → マニュアル商品登録
 *   TAKE 8 (productsManualFirst)       → 案件登録
 *   SAITE (amazonIntegration=false)    → プロジェクト登録
 */
export function manualProductTabLabel(config: Pick<BrandConfig, 'features' | 'labels'>): string {
  const amazonFirst = config.features.amazonIntegration && !config.features.productsManualFirst;
  return `${amazonFirst ? 'マニュアル' : ''}${config.labels.productShort}登録`;
}
